import { Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import FigmaIconFrame from './FigmaIconFrame'
import { scale } from '../../theme/scale'
import { HOME_MOBILE_MQ } from '../home/homeMobileLayout'
import { mobileCardBodySx, mobileCardTitleSx } from '../../theme/mobileLayout'

export const initiativeCardShadow = '0px 0px 8px 0px rgba(0,0,0,0.12)'

export default function InitiativeCard({
  title,
  description,
  iconSrc,
  iconBgColor = 'rgba(8,39,83,0.12)',
  to,
  path,
  sx = {},
}) {
  const linkTo = to ?? path

  return (
    <Box
      component={linkTo ? RouterLink : 'div'}
      to={linkTo}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: { xs: 'auto', sm: 340, md: 360, lg: 381 },
        borderRadius: { xs: '16px', sm: '18px', lg: '20px' },
        bgcolor: '#fffefa',
        boxShadow: initiativeCardShadow,
        p: { xs: '24px', sm: '22px', lg: '24px' },
        [HOME_MOBILE_MQ]: { p: '24px' },
        boxSizing: 'border-box',
        textDecoration: 'none',
        color: '#111',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '44px', sm: '64px', md: '80px', lg: `${scale.gap.xl}px` },
          [HOME_MOBILE_MQ]: { gap: '44px' },
          width: '100%',
          flex: 1,
        }}
      >
        <FigmaIconFrame
          src={iconSrc}
          bgColor={iconBgColor}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '10px', lg: '12px' } }}>
          <Typography
            sx={{
              fontSize: { xs: 24, sm: 24, md: 26, lg: 28 },
              [HOME_MOBILE_MQ]: { fontSize: 24 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
              ...mobileCardTitleSx,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 17, md: 18, lg: 20 },
              lineHeight: { xs: 1.45, lg: 'normal' },
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
              ...mobileCardBodySx,
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
